import BaseRestService from "../../../../Shared/Service/BaseRestService";
import { CARDS_TEMPLATES } from "../../../../../optics/components/drawers/templates/features/cards/cards-templates";
import { UnsplashService } from "@Shared/Components/Background/RestService";

const STATIC_FILES_PATH =
  "https://caelor-apps.web.app/images/illustrations/illustration";

class RestService extends BaseRestService {
  async generateCards(input, parameters, emojiEnabled, values) {
    const clientConfig = await this.buildJWTAuthAxiosConfig();

    let content = Object.values(parameters)
      .filter((value) => value)
      .map(({ value }) => value)
      .join(", ");

    content = `${input} ${content ? `(${content})` : ""}`;

    const { data } = await this.client.post(
      "/api/ai/cards",
      { emojiEnabled, content },
      { ...clientConfig, timeout: 180000 }
    );

    const defaultCard = values.cards[0].card || CARDS_TEMPLATES[0].card;
    const config = { ...values.config, hasTabs: false };

    const cards = await Promise.all(
      data.cards.map(async (card) => {
        const { data } = await UnsplashService.searchImages(
          card.topic,
          1,
          null,
          null,
          1
        );

        const image = data.results[0] || defaultCard.image;
        const imageUrl = image.urls.thumb.replace("&q=80&w=200", "&q=80&w=400");
        const randomNumber = Math.floor(Math.random() * 50) + 1;

        const illustration = {
          source: "csf",
          imageUrl: `${STATIC_FILES_PATH}-${randomNumber}.svg`,
          link: `${STATIC_FILES_PATH}-${randomNumber}.svg`,
          id: crypto.randomUUID(),
        };

        const unsplash = {
          source: "unsplash",
          imageUrl: imageUrl,
          link: imageUrl,
          id: image.id,
        };

        return {
          ...defaultCard,
          id: Math.random().toString(36).substring(7),
          tabId: undefined,
          overlay: {
            isActive: false,
            color: "#000",
            opacity: 0.3,
          },
          title: card.title,
          label: card.label,
          text: card.text,
          icon: card[card.iconType],
          quote: card.quote,
          image: config.type === "illustration" ? illustration : unsplash,
        };
      })
    );

    // return formatData({ cards, config });

    return { cards, config };
  }
}

export const checkIfAdmin = async () => {
  const res = await window.AP.request(
    "/rest/api/user/current?expand=operations"
  );

  const user = JSON.parse(res.body);

  const isAdmin = user.operations.some(
    (o) => o.operation === "administer" && o.targetType === "application"
  );

  return isAdmin;
};

export const checkIfRequestActive = () => {
  return document.querySelector(".intelligence-loading");
};

export const restService = new RestService();
